import DefaultMapCenterSection from './DefaultMapCenterSection';

export default DefaultMapCenterSection;
